import { render } from "./SaveImmigration.vue?vue&type=template&id=77a49cec"
import script from "./SaveImmigration.vue?vue&type=script&lang=js"
export * from "./SaveImmigration.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__